<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row justify-content-between justify-content-xxl-center">
                    <div class="col-12 col-lg-6 col-xxl-6 col-xxxl-4 d-flex align-items-lg-center">
                        <h3 class="font-size-h1 text-center text-lg-start w-100">{{sectionBlock.sectionTitle}}</h3>

                    </div>
                    <div class="col-12 col-lg-6 col-xxl-5 col-xxxl-4 offset-xxl-1">
                        <div class="row justify-content-center justify-content-lg-end">
                            <div class="col-12">

                                <h3
                                    class="font-size-200 text-red text-center text-lg-end"
                                    data-count-up="26"
                                >
                                </h3>

                                <!-- <h3 class="font-size-200 text-red text-center text-lg-end" data-count-up="26">
                                    {{yearsPassed(sectionBlock.counterDate.date)}}
                                </h3> -->
                            </div>
                            <div class="col-12 col-sm-8 col-lg-10 col-xl-10 col-xxl-8">
                                <h5 class="text-center text-lg-end pe-lg-5">{{sectionBlock.sectionSubTitle}}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'


import { CountUp } from 'countup.js';

// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'counterSection',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        yearsPassed(oldDate) {
            const today = dayjs(new Date())
            return today.diff(oldDate, 'year')
        },
    },
    // On loaded...
    mounted() {
        setTimeout(() => {
            // In View Observer trigger Anims
            const cSelectors = '[data-count-up]';
            const cElements = [].slice.call(document.querySelectorAll(cSelectors));

            const options = {
                duration: 5,
                useGrouping: false,
                enableScrollSpy: true,
            };

            setTimeout(function () {
                cElements.forEach(function (elem) {
                    new CountUp(elem, elem.getAttribute('data-count-up'), options);
                });
            }, 15);
        }, 15);
    },
}
</script>
